<template>
    <transition name="toolbar-slide">
        <div
            v-if="isToolbarVisible"
            class="emails-toolbar-container"
            :class="{ 'listingBatchToolbar--new': useNewUi }"
        >
            <div class="emails-toolbar">
                <span class="typographies-paragraph-medium-bold btn-cancel-selected-items">
                    <CompassIconButton icon="close" variant="contrast" @click="closeToolbar" />
                    {{
                        $t.n__(
                            'common.labels.selected',
                            null,
                            selectedEmails.length,
                            selectedEmails.length,
                        )
                    }}
                </span>
                <CompassButton
                    :label="$t.__('common.actions.manage_related')"
                    type="tertiary-contrast"
                    leftIcon="objects-linked"
                    @click="handleUpdateRelated"
                />
            </div>
        </div>
    </transition>
</template>

<script>
import Feature from 'Services/Feature';

export default {
    props: {
        selectedEmails: {
            type: Array,
            default: () => [],
        },
        isToolbarVisible: {
            type: Boolean,
        },
    },
    emits: ['closeToolbar', 'open:related'],
    computed: {
        useNewUi() {
            return Feature.isEnabled('new-listing-ui');
        },
    },
    methods: {
        closeToolbar() {
            this.$emit('closeToolbar');
        },
        handleUpdateRelated() {
            this.$emit('open:related', this.selectedEmails);
        },
    },
};
</script>

<style lang="scss" scoped>
@use '~@sellsy/styleguide/src/_variables' as *;

.toolbar-slide-enter-active,
.toolbar-slide-leave-active {
    transition: transform 0.3s ease-in-out;
}

.toolbar-slide-enter-from,
.toolbar-slide-leave-to {
    transform: translateY(110px);
}

.emails-toolbar-container {
    position: fixed;
    left: $listing-batch-toolbar-left;
    right: $listing-batch-toolbar-right;
    bottom: $listing-batch-toolbar-bottom;
    z-index: 3;

    &.listingBatchToolbar--new {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        bottom: auto;
        margin-top: var(--spacing-4);
    }
}

.emails-toolbar {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    border-radius: var(--spacing-0);
    padding: var(--spacing-3) var(--spacing-4);
    gap: var(--spacing-3);
    color: var(--colors-common-text-standard-on-color);
    background-color: var(--colors-common-border-primary-hover);
}

.btn-cancel-selected-items {
    display: flex;
    align-items: center;
    gap: var(--spacing-0);
    padding-right: var(--spacing-4);
    border-right: 1px solid var(--colors-common-border-lighter);
}
</style>
